const requisitionCreateInputsById = [
  "collaborator",
  "clientId",
  "orderingClientPhysId",
  "isProviderSignature",
  "clientOrderId",

  "patientLastName",
  "patientFirstName",
  "patientMiddleName",
  "patientDob",
  "patientGenderCode",
  "isDiabetic",
  "isFamilyHistory",

  "dateCollected",
  "timeCollected",
  "timeCollectedAmPm",

  "testOrderedCodes",
  "specContainerTypeCode",
  "specimenConditionCode",
  "tubeCount",
  "panelIds",
  "testIds",
  "dateReceived",
  "timeReceived",
  "dateReceivedAmPm",

  "reqBillTypeCode",
  "isInsCardProvided",
  "isSelfPayProvided",
  "isIcdProvided",
  "patientEmail",
  "guarantorAddr1",
  "guarantorAddr2",
  "guarantorCity",
  "guarantorCountryId",
  "guarantorStateId",
  "guarantorZip",
  "failIds",
];

export default requisitionCreateInputsById;
